'use strict';

// Services
import ListModel from 'common/components/list/listModel.service';
import { validAccess } from 'accessControl';
const __endpoints = require('endpoints.service');

export default class WorkplaceThirdPartyReferencesList extends ListModel {
	constructor(reduxKey) {
		super(reduxKey);
		this.headers = [
			{
				name: 'open_weather_city_id',
				type: 'string',
				canAdd: true,
				canEdit: true,
				required: true,
			},
			{
				name: 'deliveroo_restaurant',
				type: 'string',
				canAdd: true,
				canEdit: true,
				required: true,
			},
			{
				name: 'adyen_merchant_account',
				type: 'string',
				canAdd: true,
				canEdit: true,
				required: true,
			},
		];

		this.settings = {
			name: 'WorkplaceThirdPartyReferencesList',
			canAdd: true,
			canEdit: true,
			canDelete: true,
			canCollapse: true,
			alwaysRefresh: true,
			canManipulate: () => validAccess(undefined, ['Organisation/Workplaces::Edit', 'Organization Admin']),
			translationPath: 'ADMINISTRATION.WORKPLACE_THIRD_PARTY_REFERENCES',
			endpoint: __endpoints.collection.administration.workplace_third_party_references,
		};
		this.init();
		return this;
	}
}
